import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
}
)
export class MessageService {

  adminstratorCallError: any = 'Server did not respond, please contact your administrator';
  unknownErrorCall: any = 'An unknown error was thrown, please contact your administrator'; 
  pageNotFound_404: any = 'Page Not Found';
  forbidden_403: any = 'Forbidden Page';
  unAuthAccess_401: any = 'Unauthorized Access';
  badRequest_400: any = 'Bad Request';
  serverError_500:any = 'Internal Server Error';
  notImplemented_501: any = 'Not Implemented';
  badGateway_502: any = 'Bad Gateway';

  constructor( 
    private toastr:ToastrService, 
    private router: Router) {}


  errorHandlingStatusCode(error: any){
    const detail = error?.error?.detail ?? this.adminstratorCallError;
    if (error.status == 401) {
      // this.toastr.error(error.error.detail)
    } else if (error.status) {
      if(error.status == 500){
        if(typeof error?.error?.detail === 'string' &&
           error.error.detail.includes('An error occurred while refreshing tokens')){
          return;
        }
      }
      this.toastr.error(detail)
    } else {
      this.toastr.error(this.adminstratorCallError)
    }
    //  else if (error.status == 403){
    //   this.toastr.error(this.forbidden_403)
    //  }
    //  else if (error.status == 404){
    //   this.toastr.error(this.pageNotFound_404)
    //  }
    //  else if (error.status == 400){
    //   this.toastr.error(this.badRequest_400)
    //  }
    //  else if (error.status == 500){
    //   this.toastr.error(this.serverError_500)
    //  }
    //  else if (error.status == 501){
    //   this.toastr.error(this.notImplemented_501)
    //  }
    //  else if (error.status == 502){
    //   this.toastr.error(this.badGateway_502)
    //  }

    //  else{
    //   this.toastr.error(this.adminstratorCallError)
    //  }
  }

}
